/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FinancingType = {
    Conventional: 'conventional',
    Fha: 'fha',
    Va: 'va',
    Cash: 'cash',
    HardMoney: 'hard_money',
    Other: 'other'
} as const;
export type FinancingType = typeof FinancingType[keyof typeof FinancingType];


export function FinancingTypeFromJSON(json: any): FinancingType {
    return FinancingTypeFromJSONTyped(json, false);
}

export function FinancingTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingType {
    return json as FinancingType;
}

export function FinancingTypeToJSON(value?: FinancingType | null): any {
    return value as any;
}

